module.exports = __webpack_public_path__ + "static/media/Public_relations_1_B.f0fc9cb1.png";